import FormCreateAccountReminder from './FormCreateAccountReminder';

export default FormCreateAccountReminder;
